import { Effect, Schema as S } from "effect";

export const GetKimAccountsRequestSchema = S.Struct({
  authorisedUsers: S.String,
  sort: S.optional(S.String),
  page: S.optional(S.Int).pipe(S.withDecodingDefault(Effect.succeed(0))),
  itemsPerPage: S.optional(S.Int).pipe(S.withDecodingDefault(Effect.succeed(1000))),
  noCountLimit: S.optional(S.Union([S.Literal("true"), S.Literal("false")])).pipe(
    S.withDecodingDefault(Effect.succeed("false" as const)),
  ),
  creationDate: S.optional(S.String),
  creationDate_lt: S.optional(S.String),
  creationDate_gt: S.optional(S.String),
});

export type GetKimAccountsRequest = S.Schema.Type<typeof GetKimAccountsRequestSchema>;
